import {cva} from 'class-variance-authority';

export const buttonGroupVariants = cva(
  [
    'flex w-fit items-stretch',
    'has-[>[data-slot=button-group]]:gap-2',
    'has-[select[aria-hidden=true]:last-child]:[&>[data-slot=select-trigger]:last-of-type]:rounded-r-lg',
    '*:focus-visible:relative *:focus-visible:z-10',
    "[&>[data-slot=select-trigger]:not([class*='w-'])]:w-fit",
    '[&>input]:flex-1',
  ],
  {
    variants: {
      orientation: {
        horizontal: [
          '[&>*]:!shadow-none',
          '[&>[data-slot]:not(:has(~[data-slot]))]:rounded-r-lg!',
          '[&>*:not(:first-child)]:rounded-l-none',
          '[&>*:not(:last-child)]:rounded-r-none',
        ],
        vertical: [
          '[&>*]:!shadow-none',
          '[&>[data-slot]:not(:has(~[data-slot]))]:rounded-b-lg!',
          'flex-col',
          '[&>*:not(:first-child)]:rounded-t-none',
          '[&>*:not(:last-child)]:rounded-b-none',
        ],
      },
      seamless: {
        true: '',
        false: '',
      },
    },
    compoundVariants: [
      {
        orientation: 'horizontal',
        seamless: true,
        class: '[&>*:not(:first-child)]:!border-l-0 [&>*:not(:last-child)]:!border-r-0',
      },
      {
        orientation: 'vertical',
        seamless: true,
        class: '[&>*:not(:first-child)]:!border-t-0 [&>*:not(:last-child)]:!border-b-0',
      },
      {
        orientation: 'horizontal',
        seamless: false,
        class: '[&>*:not(:first-child)]:border-l-0',
      },
      {
        orientation: 'vertical',
        seamless: false,
        class: '[&>*:not(:first-child)]:border-t-0',
      },
    ],
    defaultVariants: {
      orientation: 'horizontal',
      seamless: false,
    },
  },
);
